import styled from 'styled-components'
import { Skeleton } from '@material-ui/lab'

export const Root = styled(Skeleton)`
  background-color: ${props => props.theme.palette.brand.gray[90]};
  border-radius: ${props => (props.variant === 'circle' ? '50%' : '3px')};
  display: inline-block;
  margin: ${props => props.margin};
  opacity: 0.1;
  padding: ${props => props.padding};
  width: ${props => props.width || '100%'};
`
